import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, cx } from '@emotion/css';
import { FractalFLogo } from "./fractal-f-logo.js";
import { getDefaultButtonStyles } from "./styles.js";
import { assertUnreachable } from "../lib/assertions/index.js";
export const Button = ({ children, onClick, theme, ...buttonProps }) => {
    const { buttonBackground, buttonBackgroundOnHover, logoBackground, logoFill, textColor, } = getColorsFromVariant(theme);
    const defaultButtonStyles = getDefaultButtonStyles({
        buttonBackground,
        buttonBackgroundOnHover,
        textColor,
    });
    return (_jsxs("button", { ...buttonProps, onClick: onClick, className: cx(defaultButtonStyles, buttonProps.className), children: [_jsx("div", { className: css `
          height: 2.25rem;
          aspect-ratio: 1/1;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${logoBackground};
          border-radius: 0.125rem;
        `, children: _jsx(FractalFLogo, { fill: logoFill }) }), _jsx("div", { className: css `
          padding: 0 0.75rem;
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
        `, children: children })] }));
};
function getColorsFromVariant(variant) {
    switch (variant) {
        case 'light':
            return {
                buttonBackground: '#c31a88',
                buttonBackgroundOnHover: '#d71d96',
                logoBackground: '#f2059f',
                logoFill: '#fff',
                textColor: '#fff',
            };
        case 'dark':
            return {
                buttonBackground: '#000',
                buttonBackgroundOnHover: '#181818',
                logoBackground: '#232323',
                logoFill: '#f2059f',
                textColor: '#fff',
            };
        default:
            assertUnreachable(variant);
    }
}
//# sourceMappingURL=button.js.map